import { render, staticRenderFns } from "./InfoWindow.vue?vue&type=template&id=0612a988&scoped=true&"
import script from "./InfoWindow.vue?vue&type=script&lang=js&"
export * from "./InfoWindow.vue?vue&type=script&lang=js&"
import style0 from "./InfoWindow.vue?vue&type=style&index=0&id=0612a988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0612a988",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0612a988')) {
      api.createRecord('0612a988', component.options)
    } else {
      api.reload('0612a988', component.options)
    }
    module.hot.accept("./InfoWindow.vue?vue&type=template&id=0612a988&scoped=true&", function () {
      api.rerender('0612a988', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Map/components/mapbox/InfoWindow.vue"
export default component.exports